import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "children", "onClick", "contentFrom", "tabValue"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-06 18:44:46
 * @LastEditTime: 2022-03-17 17:22:05
 * @LastEditors: wangshengqiang
 * @Description: TODO 保障详情用到了
 */
import React, { useState } from 'react';
import classnames from 'classnames';
import { Toast, Popup } from 'zarm';
import { stringify } from 'qs';
import request from '@/utils/request';
import { getQueryParam } from '@/utils/queryString';
import session from '@/store/session';
import { getFetchBaseData } from '@/utils/utils';
import PDFView from '@/components/PDFView';
import Gs from '@/Gs';
import './index.less';

const getFileId = (element, name = 'data-file-id') => {
  if (!element) {
    return;
  }

  const {
    parentElement
  } = element;
  const fileId = element.getAttribute(name);
  return fileId || getFileId(parentElement);
};

const Content = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    pdfUrl,
    imgUrl
  } = Gs.config;
  const [popupVisble, setPopupVisble] = useState();
  const [popContent, setPopContent] = useState(null);

  const {
    className,
    children,
    onClick: propsOnClick,
    contentFrom = false,
    tabValue = 1
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const cls = classnames({
    'components-content-render': true,
    [className]: !!className
  });

  const onClick = async (e = {}) => {
    propsOnClick && propsOnClick(e);
    const {
      target = {}
    } = e;
    const {
      innerText
    } = target;
    const fileId = getFileId(target);
    const documentId = getFileId(target, 'data-document-id');

    if (!fileId && !documentId) {
      return;
    }

    e.stopPropagation();
    let res = {};

    if (fileId) {
      const opts = {
        METHOD: 'POST',
        data: {
          id: fileId
        }
      };
      res = (await request('/v1/document/queryDocumentDetail', opts)) || {};
    } else if (documentId) {
      const opts = {
        METHOD: 'POST',
        data: getFetchBaseData()
      };
      res = (await request('/goods/v1/document/getDynamicDocumentUrl', opts)) || {};
      res.success && (res.result = {
        type: 'file',
        content: res.result
      });
    }

    const {
      code,
      message,
      result = {}
    } = res;

    if (Number(code)) {
      Toast.show(message || '网络异常，请稍后重试');
    } else {
      const {
        type,
        content,
        name = ''
      } = result;

      switch (type) {
        case 'file':
          {
            const url = `/api/v1/document/previewFile?${stringify({
              fileName: `${name}.pdf`
            })}`;
            PDFView.view(url);
            break;
          }

        case 'url':
          {
            const link = content && content.replace(/^http:/, 'https:');
            const {
              from,
              tenantFrom
            } = getQueryParam();
            const qFrom = tenantFrom || from || '';
            let href = link;

            if (typeof link === 'string' && link.includes('pdf')) {
              href = `${pdfUrl}?file=${encodeURIComponent(`${link}#zhongan.com`)}`;
            }

            if (typeof link === 'string' && (link.includes('jpg') || link.includes('png') || link.includes('gif') || link.includes('svg') || link.includes('webp') || link.includes('bmp'))) {
              href = `${imgUrl}?file=${encodeURIComponent(`${link}#zhongan.com`)}`;
            }

            if (contentFrom === 'popup') {
              session.set('supervisionPopupShow', true);
              session.set('supervisionPopupShowTab', tabValue);
            }

            window.location.href = href;
            break;
          }

        default:
          {
            const dangerouslySetInnerHTML = {
              __html: content
            };

            const _children = /*#__PURE__*/React.createElement("div", {
              className: "content-module"
            }, /*#__PURE__*/React.createElement("div", {
              className: "module-header"
            }, innerText || ''), /*#__PURE__*/React.createElement(Content, {
              className: "module-body ql-editor",
              dangerouslySetInnerHTML: dangerouslySetInnerHTML
            }));

            setPopContent(_children);
            setPopupVisble(true); // const operations = [
            //   {
            //     shadow: true,
            //     type: 'primary',
            //     children: '关闭',
            //   },
            // ];
            // Modal.show({ children: _children, operations });
            // break;
          }
      }
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cls,
    onClick: onClick
  }, others), children), /*#__PURE__*/React.createElement(Popup, {
    visible: popupVisble,
    direction: "bottom",
    onMaskClick: () => setPopupVisble(false) // afterOpen={() => console.log('打开')}
    // afterClose={() => console.log('关闭')}
    ,
    destroy: false,
    mountContainer: () => document.body
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup-box",
    style: {
      minHeight: '350px',
      maxHeight: '75vh'
    }
  }, popContent)));
});
export default Content;